import React from "react";
import { BaseButton } from "./BaseButton";

export function SecondaryButton(props) {
	return <BaseButton {...props}>{props.children}</BaseButton>;
}
